import { Box, styled, Theme, ThemeProvider } from "@mui/material";

import { getStyles } from "./utils/styles";

export const PopupWrapper = styled(Box)(({ theme }) => ({
  maxWidth: 460,
  minWidth: 420,
  fontSize: theme.fontSizes.md,
  boxShadow: "none",

  [theme.breakpoints.down("md")]: {
    fontSize: theme.fontSizes.sm,
    maxWidth: 300,
    minWidth: 220,
  },
}));

export function TooltipWrapper({ date, children, theme }: { date: string; children: React.ReactNode; theme: Theme }) {
  return (
    <ThemeProvider theme={theme}>
      <PopupWrapper>
        <Box sx={getStyles(theme).textSecondary}>{date}</Box>
        <Box>{children}</Box>
      </PopupWrapper>
    </ThemeProvider>
  );
}
